import type { AthenaCliUI } from "../../cli/ui/index.ts";
import { createPostgresPool } from "../../postgres/driver.ts";
import { applyEmbeddedSqlMigrations } from "../embedded-sql-apply.ts";
import type { RunMigrationsOptions } from "../types.ts";
import { EMBEDDED_CHAT_LEDGER, EMBEDDED_CHAT_MIGRATIONS } from "./catalog.ts";
import {
	shouldApplyEmbeddedChatMigrations,
	type AthenaChatMigrationModules,
} from "./enablement.ts";

export async function applyEmbeddedChatMigrations(
	options: RunMigrationsOptions,
	connectionString: string,
	ui: AthenaCliUI,
	modules: AthenaChatMigrationModules | undefined,
): Promise<void> {
	if (!shouldApplyEmbeddedChatMigrations(modules)) {
		return;
	}
	if (options.createBackend && !options.createAuthDatabase) {
		return;
	}
	ui.info("→ Embedded Chat schema applying");
	const pool = await createPostgresPool(connectionString, { max: 4, min: 0 });
	try {
		await applyEmbeddedSqlMigrations({
			ledgerTable: EMBEDDED_CHAT_LEDGER,
			migrations: EMBEDDED_CHAT_MIGRATIONS,
			pool,
			ui,
		});
	} finally {
		await pool.end();
	}
	ui.success("✓ Embedded Chat schema applied");
}
